'use strict';

var processInclude = require('theme/js/util');

jQuery(function () {
    processInclude(require('theme/js/loginModal/loginModal'));
});
